import PropTypes from 'prop-types';
import React from 'react';

// The color arrives as an inline style rather than a `fill` attribute: a
// presentation attribute is parsed outside the cascade, where `var()` never
// resolves, and a consumer's mapped palette can hand this one. The trade is
// that `useClass` cannot override the fill.
const SVG = ({ color, useClass }) => (
  <svg className={useClass} fill="none" height="8" viewBox="0 0 8 8" width="8" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.66673 2.33334H0.333397C0.272689 2.33336 0.213141 2.34443 0.161178 2.36536C0.109215 2.38628 0.0668115 2.41627 0.0385427 2.45209C0.010274 2.48791 -0.00278632 2.52819 0.000771337 2.5686C0.00432899 2.609 0.0243695 2.64799 0.0587301 2.68135L3.7254 6.23703C3.75603 6.26673 3.79704 6.29102 3.84489 6.3078C3.89274 6.32458 3.946 6.33334 4.00006 6.33334C4.05413 6.33334 4.10738 6.32458 4.15524 6.3078C4.20309 6.29102 4.2441 6.26673 4.27473 6.23703L7.9414 2.68135C7.97576 2.64799 7.9958 2.609 7.99936 2.5686C8.00291 2.52819 7.98985 2.48791 7.96158 2.45209C7.93332 2.41627 7.89091 2.38628 7.83895 2.36536C7.78699 2.34443 7.72744 2.33336 7.66673 2.33334Z"
      style={{ fill: color }}
    />
  </svg>
);

SVG.propTypes = {
  color: PropTypes.string,
  useClass: PropTypes.string,
};

SVG.defaultProps = {
  color: 'currentColor',
  useClass: '',
};

export default SVG;
